<template>
  <div v-if="isShown" @click="onWrapperClick" class="modal-wrapper">
    <div class="modal-content">

      <!-- Title -->
      <h1 class="title">{{ modalOptions.title }}</h1>

      <!-- Text -->
      <p v-html="modalOptions.text" class="text"></p>

      <!-- Custom content slot -->
      <slot name="content"/>

      <!-- Buttons -->
      <div class="buttons-wrapper">

        <!-- Button loop: click action, text, type, class-->
        <!-- Extra button slot -->
        <slot name="extraButton"></slot>

        <!-- Close button -->
        <DButton @click.native="close()"
                 :text="modalOptions.buttonLeft"
                 :class="modalOptions.buttonLeftClass ? modalOptions.buttonLeftClass : 'button-border'"
                 type="button"
                 class="modal-button"/>

        <!-- Execute button -->
        <DButton @click.native="execute()"
                 :text="modalOptions.buttonRight"
                 :class="modalOptions.buttonRightClass ? modalOptions.buttonRightClass : ''"
                 :disabled="disabledRightButton"
                 type="submit"
                 class="button-main modal-button"/>
      </div>
    </div>
  </div>
</template>

<script>
import {computed} from "@vue/composition-api";
import {RESET_MODAL_OPTIONS} from "../../store/mutations";
import DButton from "../elements/DButton";

export default {
  name: "Modal",
  props: {
    disabledRightButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    DButton,
  },
  emits: ['execute', 'close'],
  setup(props, {root, emit}) {
    const store = root.$store;

    const modalOptions = computed(() => store.getters.getModalOptions);
    const activeModal = computed(() => store.getters.getActiveModal);
    const isShown = computed(() => store.getters.isModalShown);

    function execute() {
      if (modalOptions.value?.callback) {
        modalOptions.value.callback();
      }
      emit('execute');
    }

    function close() {
      if (modalOptions.value?.cancelCallback) {
        modalOptions.value.cancelCallback();
      } else {
        store.commit(RESET_MODAL_OPTIONS);
      }
    }

    /** UI Helpers **/
    function onWrapperClick(event) {

      // If the user has clicked on the overlay, the modal should close.
      if (event.target.classList.contains('modal-wrapper')) {
        this.close();
        emit('close');
      }
    }


    return {
      modalOptions,
      activeModal,
      isShown,
      execute,
      close,

      /** UI Helpers **/
      onWrapperClick
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../assets/css/base.mixins";

$modal-border: #ECECEC;

.modal-wrapper {
  @include position-elevation(fixed, $top: 0, $right: 0, $bottom: 0, $left: 0, $elevation: var(--modal-index));
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
}

.modal-content {
  background-color: white;
  border: rem(1) solid $modal-border;
  border-radius: rem(10);
  box-shadow: rem(2) rem(4) rem(8) 0 rgba(70, 70, 70, 0.1);
  margin: 0 rem(34);
  max-width: rem(440);
  padding: rem(40);
  text-align: left;
  width: 100%;
}

// Texts
.title {
  color: var(--black-dark);
  font-size: rem(34);
  font-weight: bold;
  line-height: rem(22);
  margin-bottom: rem(41);
}

.text {
  color: var(--black-light);
  font-family: "Open Sans";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: rem(40);
  text-align: left;
}

// Buttons
.buttons-wrapper {
  display: flex;
  justify-content: space-between;

}

.modal-button {
  width: rem(133);
}

.modal-button-100 {
  width: rem(100);
}

</style>
